import { FC, useCallback, useState } from "react";

import { SchematisationRevision } from "@nens/threedi/openapi-client";

import { getSchematisationsApi } from "../../apiConfiguration";
import ButtonWithConfirmation from "../../components/ButtonWithConfirmation";

interface NoModelYetProps {
  callbackToLoadModel: () => void;
  revision: SchematisationRevision;
  schematisationId: number;
}

// No model yet, show option to generate one.

const NoModelYet: FC<NoModelYetProps> = ({ revision, schematisationId, callbackToLoadModel }) => {
  const [creationError, setCreationError] = useState(false);

  const createModel = useCallback(() => {
    (async () => {
      const schematisationsApi = getSchematisationsApi();

      if (!revision.id) {
        return;
      }

      try {
        await schematisationsApi.schematisationsRevisionsCreateThreedimodel({
          id: revision.id,
          schematisationPk: schematisationId,
          data: { inheritFromPreviousRevision: true },
        });

        callbackToLoadModel();
      } catch (error) {
        console.error(error);
        setCreationError(true);
      }
    })();
  }, [callbackToLoadModel, revision, schematisationId]);

  return revision.isValid ? (
    <>
      <p>This revision does not have a model yet.</p>
      <ButtonWithConfirmation
        buttonText="Generate a Rana model for this revision."
        dialogTitle="Really generate?"
        confirmationButtonText="Generate"
        confirmationButtonSafety="safe"
        onClick={createModel}
        disableAfterClick
      >
        <p>
          This generates a Rana model for this revision, so that simulations with it can be run. It
          takes up some storage space.
        </p>
        <p>Generate this model?</p>
      </ButtonWithConfirmation>
      {creationError ? (
        <p>
          Model generation failed. There is a maximum number of models per schematisation, you may
          need to delete some.
        </p>
      ) : null}
    </>
  ) : (
    <p>This revision has no model. As it is not (yet) valid, no model can be created.</p>
  );
};

export default NoModelYet;
